/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
/**
 * Represents a request to be executed in a batch
 *
 * @class BatchRequest
 */
export class BatchRequest {
    constructor(index, id, resource, method) {
        this.resource = resource.startsWith('/') ? resource : `/${resource}`;
        this.method = method;
        this.index = index;
        this.id = id;
    }
}
